export enum DocumentType {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2
}

export enum FrequencyEnum {
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_3 = 3,
    NUMBER_4 = 4
}

export enum ImageType {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2
}

export interface ChatBotCitation {
    article_id?: number;
    page_number?: number;
    date?: string;
}

export interface ContentWatchDto {
    frequency?: FrequencyEnum;
    isEverything?: boolean;
    userOnlySubscriptionPackage?: boolean;
    subscriptionPackages?: number[] | null;
    tags?: number[] | null;
    isDailyDishEnabled?: boolean | null;
    isNewsArticleEnabled?: boolean | null;
}

export interface ContentWatchEmailModel {
    emailTo?: string | null;
    userFirstName?: string | null;
    tags?: string[] | null;
    userOnlySubscriptionPackage?: boolean;
    publications?: ContentWatchEmailPublicationModel[] | null;
    companyId?: number | null;
    userId?: number;
    contentWatchLink?: string | null;
}

export interface ContentWatchEmailPublicationModel {
    id?: number;
    image?: string | null;
    name?: string | null;
    description?: string | null;
    link?: string | null;
}

export interface GetAllWithFilterModel {
    ribbonsIds?: number[] | null;
    categoriesIds?: number[] | null;
    includeAnySubscriptionPackageIds?: number[] | null;
    includeAllSubscriptionPackageIds?: number[] | null;
    includeAnyTagsIds?: number[] | null;
    includeAllTagsIds?: number[] | null;
    types?: DocumentType[] | null;
    searchText?: string | null;
    skip?: number;
    take?: number;
    orderBy?: string | null;
    sortOrder?: string | null;
    hasAccess?: boolean;
}

export interface NewsArticleDetail {
    content?: string | null;
    publishedDate?: string | null;
    tags?: string[] | null;
    tagItems?: { id: number; value: string }[] | null;
    id?: number;
    featuredImage: string;
    title: string;
    description: string;
}

export interface NewsArticleFilter {
    tags?: number[] | null;
    searchTerm?: string | null;
    sortOrder?: string | null;
    orderBy?: string | null;
    skip?: number;
    take?: number;
}

export interface NewsArticleLikeDislikeRequest {
    newsArticleId: number;
    isLiked: boolean;
}

export interface NewsArticleModel {
    publishedDate: string;
    type: string;
    tags?: string[] | null;
    content: string;
    referenceArticles?: number[] | null;
    id?: number;
    featuredImage: string;
    title: string;
    description: string;
}

export interface RecentNewsArticleModel {
    publishedDate?: string;
    id?: number;
    featuredImage: string;
    title: string;
    description: string;
}

export interface SearchRequestModel {
    query?: string | null;
    inMyLibrary?: boolean;
    skipDocs?: number;
    takeDocs?: number;
    skipMacs?: number;
    takeMacs?: number;
}

export interface iMacSnapLight__API {
    id?: number;
    title?: string | null;
    createDate?: string | null;
    updateDate?: string | null;
    bigImageName?: string | null;
}

export interface ElasticSuggest {
    contexts?: any | null;
    input?: string[] | null;
    weight?: number;
}

export interface SnapElasticDocument {
    documentType?: number;
    featureId?: number;
    price?: number;
    companiesIds?: number[] | null;
    isPrivate?: boolean;
    modifiedByUser?: string | null;
    modifiedDate?: string | null;
    phase?: number;
    isArchived?: boolean;
    canPurchase?: boolean;
    hidden?: boolean;
    databaseId?: number;
    date?: string | null;
    dateTime?: string | null;
    description?: string | null;
    fileExtention?: string | null;
    fileSize?: number;
    fileName?: string | null;
    id?: number;
    instanceId?: number;
    pages?: number;
    parentId?: number;
    parentGuid?: string | null;
    parentPages?: number;
    projectsJson?: string | null;
    publicationFamily?: string | null;
    sampleFile?: string | null;
    title?: string | null;
    categoryId?: number;
    penetration?: number;
    chainId?: number;
    publicationFamilyBoost?: number;
    suggest?: ElasticSuggest[] | null;
    lastUpdateDateTime?: string | null;
}

export interface iAdminRibbon__API {
    id: number;
    name: string;
    publicationIds: number[];
}

export interface iArticleAdmin__API {
    id: number;
    title: string;
    description: string;
    tagsIds: number[];
    tags?: iTagShort__API[] | null;
    numberOfPages: number;
    minutesToRead: number;
    bigImageName?: string | null;
    featuredContentImageName?: string | null;
    files: iFile__API[];
}

export interface iArticleReference__API {
    id?: number;
    title: string;
    imageUrl: string;
    hasAccess: boolean;
    files: iFile__API[];
    createDate: string;
    publicationType: DocumentType;
}

export interface iButtonCategory__API {
    titleCategories?: iTitleCategory__API[] | null;
    buttonCategories?: iTitleCategory__API[] | null;
}

export interface iChapterAdmin__API {
    publicationId: number;
    pageFrom: number;
    pageTo: number;
    id: number;
    title: string;
    description: string;
    tagsIds: number[];
    tags?: iTagShort__API[] | null;
    numberOfPages: number;
    minutesToRead: number;
    bigImageName?: string | null;
    featuredContentImageName?: string | null;
    files: iFile__API[];
}

export interface iCompaniesWithUsers__API {
    companies?: number[] | null;
    users?: string[] | null;
}

export interface iFile__API {
    filename: string;
    type: string;
}

export interface i__APIsLatestNewsAndPublication {
    publications?: iPublicationClient__API[] | null;
    news?: RecentNewsArticleModel[] | null;
}

export interface iPublicationAdmin__API {
    price?: number | null;
    isPublished?: boolean;
    isTesting?: boolean;
    createDate: string;
    buttonCategoryId?: number;
    titleCategoryId?: number;
    chapters?: iChapterAdmin__API[] | null;
    subscriptionPackageIds: number[];
    id: number;
    title: string;
    description: string;
    tagsIds: number[];
    numberOfPages: number;
    minutesToRead: number;
    bigImageName?: string | null;
    featuredContentImageName?: string | null;
    files: iFile__API[];
}

export interface iPublicationBase__API {
    id: number;
    title: string;
    snapDocumentId: number;
    createdDate: string;
}

export interface iPublicationClientDetail__API {
    publication: iPublicationClient__API;
    relatedPublications: iPublicationClient__API[];
}

export interface iPublicationClient__API {
    bigImageUrl: string;
    featuredContentImageUrl: string;
    price: number;
    createDate: string;
    updateDate: string;
    buttonCategoryId: number;
    titleCategoryId: number;
    chapters: iPublicationClient__API[];
    publicationId: number;
    pageFrom: number;
    pageTo: number;
    hasChapters?: boolean;
    publicationTitle: string;
    score?: number;
    isPublished?: boolean;
    subscriptionPackages?: iSubscriptionPackage__API[] | null;
    type?: string | null;
    pageNumber?: number;
    pages?: number[] | null;
    id?: number;
    title: string;
    description: string;
    imageUrl: string;
    tags: iTagShort__API[];
    numberOfPages: number;
    minutesToRead: number;
    isLiked: boolean;
    isShared: boolean;
    isAddedToReadingList: boolean;
    hasAccess: boolean;
    publicationType: DocumentType;
    files: iFile__API[];
    addedToReadingListDate?: string | null;
    shareOnDate?: string | null;
    createDateToOrder?: string;
}

export interface iPublicationInfo__API {
    id?: number;
    title?: string | null;
    buttonCategoryName?: string | null;
    titleCategoryName?: string | null;
    buttonCategoryId?: number;
    titleCategoryId?: number;
    featureIds?: number[] | null;
    createDate?: string;
}

export interface iPublicationShort__API {
    id: number;
    title: string;
    createDate: string;
    titleCategoryName: string;
    subscriptionPackageIds?: number[] | null;
}

export interface iPublication__API {
    chapterCount: number;
    chapters: iPublicationBase__API[];
    titleCategoryName: string;
    buttonCategoryName: string;
    id: number;
    title: string;
    snapDocumentId: number;
    createdDate: string;
}

export interface iPublicationsBlock__API {
    items?: iPublicationClient__API[] | null;
    totalCount?: number;
}

export interface iRibbon__API {
    id: number;
    name: string;
    publications: iPublicationClient__API[];
}

export interface iSearchMacs__API {
    macsResults?: iPublicationClient__API[] | null;
    macsResultsCount?: number;
}

export interface iSearch__API {
    generatedText?: string | null;
    statusCode?: number;
    macsResults?: iPublicationClient__API[] | null;
    documentsResults?: iPublicationClient__API[] | null;
    macsResultsCount?: number;
    otherResultsCount?: number;
}

export interface iSearchWithChatBot__API {
    generatedText?: string | null;
    citations?: ChatBotCitation[] | null;
    macsResults?: iPublicationClient__API[] | null;
    documentsResults?: iPublicationClient__API[] | null;
    chatBotResultsCount?: number;
    macsResultsCount?: number;
    otherResultsCount?: number;
}

export interface iSharePublication__API {
    users?: iSnapUser__API[] | null;
    message: string;
}

export interface iSnapGroup__API {
    id?: number;
    name?: string | null;
    users?: string[] | null;
}

export interface iSnapPublication__API {
    chapterCount: number;
    chapters: iPublicationBase__API[];
    publicationFamily: string;
    id: number;
    title: string;
    snapDocumentId: number;
    createdDate: string;
}

export interface iSnapUser__API {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    showOnboardingScreens: boolean;
    companyName: string;
    companyId: number;
    isInMyLibraryToggledOn: boolean;
    isAdmin: boolean;
    aiSearchEnabled?: boolean;
    globalSubscriptionPackageIds?: number[] | null;
    globalAssociatedRibbonsIds?: number[] | null;
}

export interface iSubscriptionPackage__API {
    id: number;
    name: string;
}

export interface iTagShort__API {
    id: number;
    value: string;
}

export interface iTag__API {
    publicationsIds?: number[] | null;
    id: number;
    value: string;
}

export interface iTitleCategory__API {
    id: number;
    name: string;
}

export interface iUserAccessRequest__API {
    firstName: string;
    lastName: string;
    companyName: string;
    articleId: number;
    articleTitle: string;
    userId: number;
    documentType: DocumentType;
    titleCategoryName: string;
    packages: string;
    email: string;
}

export interface TestEmail {
    emailBcc?: string | null;
    html?: string | null;
}

export enum HttpStatusCode {
    NUMBER_100 = 100,
    NUMBER_101 = 101,
    NUMBER_102 = 102,
    NUMBER_103 = 103,
    NUMBER_200 = 200,
    NUMBER_201 = 201,
    NUMBER_202 = 202,
    NUMBER_203 = 203,
    NUMBER_204 = 204,
    NUMBER_205 = 205,
    NUMBER_206 = 206,
    NUMBER_207 = 207,
    NUMBER_208 = 208,
    NUMBER_226 = 226,
    NUMBER_300 = 300,
    NUMBER_301 = 301,
    NUMBER_302 = 302,
    NUMBER_303 = 303,
    NUMBER_304 = 304,
    NUMBER_305 = 305,
    NUMBER_306 = 306,
    NUMBER_307 = 307,
    NUMBER_308 = 308,
    NUMBER_400 = 400,
    NUMBER_401 = 401,
    NUMBER_402 = 402,
    NUMBER_403 = 403,
    NUMBER_404 = 404,
    NUMBER_405 = 405,
    NUMBER_406 = 406,
    NUMBER_407 = 407,
    NUMBER_408 = 408,
    NUMBER_409 = 409,
    NUMBER_410 = 410,
    NUMBER_411 = 411,
    NUMBER_412 = 412,
    NUMBER_413 = 413,
    NUMBER_414 = 414,
    NUMBER_415 = 415,
    NUMBER_416 = 416,
    NUMBER_417 = 417,
    NUMBER_421 = 421,
    NUMBER_422 = 422,
    NUMBER_423 = 423,
    NUMBER_424 = 424,
    NUMBER_426 = 426,
    NUMBER_428 = 428,
    NUMBER_429 = 429,
    NUMBER_431 = 431,
    NUMBER_451 = 451,
    NUMBER_500 = 500,
    NUMBER_501 = 501,
    NUMBER_502 = 502,
    NUMBER_503 = 503,
    NUMBER_504 = 504,
    NUMBER_505 = 505,
    NUMBER_506 = 506,
    NUMBER_507 = 507,
    NUMBER_508 = 508,
    NUMBER_510 = 510,
    NUMBER_511 = 511
}
